<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>人事管理</el-breadcrumb-item>
      <el-breadcrumb-item>节日福利</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickRecently">显示即将到来的节假日</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="ShangJigouName" label="公司名称"></el-table-column>
          <el-table-column prop="CurJigouName" label="部门名称"></el-table-column>
          <el-table-column prop="Name" label="名称"></el-table-column>
          <el-table-column prop="Year" label="年"></el-table-column>
          <el-table-column prop="Month" label="月"></el-table-column>
          <el-table-column prop="Day" label="日"></el-table-column>
          <el-table-column prop="Feiyong" label="预算费用"></el-table-column>
          <el-table-column prop="Beizhu" label="备注"></el-table-column>
          <el-table-column prop="Name1" label="创建者"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间"></el-table-column>
          <el-table-column prop="operation" label="操作" width="200px">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickmodify(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="70px">
        <el-form-item label="名称" class="addAdminForm">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="年" class="addAdminForm">
          <el-input v-model="addForm.year"></el-input>
        </el-form-item>
        <el-form-item label="月" class="addAdminForm">
          <el-input v-model="addForm.month"></el-input>
        </el-form-item>
        <el-form-item label="日" class="addAdminForm">
          <el-input v-model="addForm.day"></el-input>
        </el-form-item>
        <el-form-item label="预算费用" class="addAdminForm">
          <el-input type="textarea" :rows="5" v-model="addForm.feiyong"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input type="textarea" :rows="5" v-model="addForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- 修改 start -->
    <el-tab-pane label="修改报表" name="three" v-if="displayEdit">
      <el-form :model="editForm" ref="editFormRef" label-width="70px">
        <el-form-item label="名称" class="addAdminForm">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="年" class="addAdminForm">
          <el-input v-model="editForm.year"></el-input>
        </el-form-item>
        <el-form-item label="月" class="addAdminForm">
          <el-input v-model="editForm.month"></el-input>
        </el-form-item>
        <el-form-item label="日" class="addAdminForm">
          <el-input v-model="editForm.day"></el-input>
        </el-form-item>
        <el-form-item label="预算费用" class="addAdminForm">
          <el-input type="textarea" :rows="5" v-model="editForm.feiyong"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input type="textarea" :rows="5" v-model="editForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 修改 end -->

    <!-- 弹出框 -->
    <el-dialog title="即将到来的节假日" :visible.sync="displaydialog" width="30%" :close-on-click-modal="false">
      <el-form :model="caiwushenheForm" ref="caiwushenheFormRef" label-width="70px">
        <el-form-item label="" class="addAdminForm">
          <p v-for="(item,i) in dataRecentlyList"> 节假日： {{item.Name}}（{{item.Month}}月{{item.Day}}日）</p>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 弹出框 end -->

  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal
  },
  name: 'MyRenShi4',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        name: '',
        year: '',
        month: '',
        day: '',
        feiyong: '',
        beizhu: ''
      },
      editForm: {
        id: '0',
        name: '',
        year: '',
        month: '',
        day: '',
        feiyong: '',
        beizhu: ''
      },
      timer: '',
      // 查询
      keywords: {
        jigouid: '-1',
        jigouname: '',
        name: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      displayEdit: false,
      filetype: 2,
      displaydialog: true,
      dataRecentlyList: [],
      caiwushenheForm: {}
    }
  },
  mounted () {
    this.apiGetErp3HolidayNum()
    this.apiGetErp3HolidayList()

    this.apiGetErp3HolidayRecentlyList()
  },
  methods: {
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickadd () {
      this.apiAddErp3Holiday()
    },
    clickreturn () {
      this.activeName = 'first'
      this.displayEdit = false
    },
    clickmodify (row) {
      this.activeName = 'three'
      this.displayEdit = true

      this.editForm.id = row.Id
      this.editForm.name = row.Name
      this.editForm.year = row.Year
      this.editForm.month = row.Month
      this.editForm.day = row.Day
      this.editForm.feiyong = row.Feiyong
      this.editForm.beizhu = row.Beizhu
    },
    clicksave () {
      this.apiEditErp3Holiday()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetErp3HolidayNum()
      this.apiGetErp3HolidayList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp3HolidayList()
    },
    clickRecently () {
      this.displaydialog = true
      this.apiGetErp3HolidayRecentlyList()
    },
    apiGetErp3HolidayNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp3HolidayNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp3HolidayList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp3HolidayList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp3Holiday: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.addForm.name,
        year: that.addForm.year,
        month: that.addForm.month,
        day: that.addForm.day,
        feiyong: that.addForm.feiyong,
        beizhu: that.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp3Holiday, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp3HolidayNum()
            that.apiGetErp3HolidayList()

            that.addForm.name = ''
            that.addForm.year = ''
            that.addForm.month = ''
            that.addForm.day = ''
            that.addForm.feiyong = ''
            that.addForm.beizhu = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditErp3Holiday: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        name: that.editForm.name,
        year: that.editForm.year,
        month: that.editForm.month,
        day: that.editForm.day,
        feiyong: that.editForm.feiyong,
        beizhu: that.editForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp3Holiday, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.displayEdit = false
            that.apiGetErp3HolidayNum()
            that.apiGetErp3HolidayList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp3HolidayRecentlyList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp3HolidayRecentlyList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataRecentlyList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
